import { NgModule } from '@angular/core';
import { AvatarDirective } from './avatar/avatar';
import { CustomBgColorDirective } from './custom-bg-color/custom-bg-color';
import { CustomTextColorDirective } from './custom-text-color/custom-text-color';
import { CustomTextSecundaryColorDirective } from './custom-text-secundary-color/custom-text-secundary-color';
import { CustomBgSecondaryColorDirective } from './custom-bg-secondary-color/custom-bg-secondary-color';
import { CustomBgInactiveColorDirective } from './custom-bg-inactive-color/custom-bg-inactive-color';
import { CustomConterbackPcDirective } from './custom-conterback-pc/custom-conterback-pc';
import { CustomBgPcDirective } from './custom-bg-pc/custom-bg-pc';
import { CustomSegmentColorDirective } from './custom-segment-color/custom-segment-color';

@NgModule({
	declarations: [AvatarDirective,
    CustomBgColorDirective,
    CustomTextColorDirective,
    CustomTextSecundaryColorDirective,
    CustomBgSecondaryColorDirective,
    CustomBgInactiveColorDirective,
    CustomConterbackPcDirective,
    CustomBgPcDirective,
    CustomSegmentColorDirective],
	imports: [],
	exports: [AvatarDirective,
    CustomBgColorDirective,
    CustomTextColorDirective,
    CustomTextSecundaryColorDirective,
    CustomBgSecondaryColorDirective,
    CustomBgInactiveColorDirective,
    CustomConterbackPcDirective,
    CustomBgPcDirective,
    CustomSegmentColorDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts